import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { trigger, transition, style, animate, keyframes } from '@angular/animations';
import { NgbAccordion, NgbModal, NgbModalConfig, NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { PermitProjectFacilityAopService, ProjectFacilityAnnualOperatingPlanApi } from 'src/app/services/permit-project-facility-aop.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { PermitAopService, PermitAnnualOperatingPlanApi } from 'src/app/services/permit-aop.service';
import { NgForm } from '@angular/forms';
import { ApplicationPackageService, ApplicationPackage } from 'src/app/services/application-package.service';
import { PermitProjectFacilityService } from 'src/app/services/permit-project-facility.service';
import { ProjectFacilitySponsorApi, ProjectFacilitySponsorService } from 'src/app/services/project-facility-sponsor.service';
import { DblistService, ListPerAcreFootCostBasisForRecharge } from 'src/app/services/dblist.service';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-aop-group',
  animations: [
    trigger('openClose', [
      transition(':enter', [
        style({ height: 0, opacity: 0 }),
        animate('0.25s', keyframes([
          style({ height: 0, opacity: 0, offset: 0 }),
          style({ height: '*', opacity: 1, offset: 1 }),
        ]))
      ]),
      transition(':leave', [
        style({ height: '*', opacity: 1, }),
        animate('0.25s', keyframes([
          style({ height: '*', opacity: 1, offset: 0 }),
          style({ height: 0, opacity: 0, offset: 1 }),
        ]))
      ])
    ])
  ],
  templateUrl: './aop-group.component.html',
  styleUrls: ['./aop-group.component.scss']
})
export class AopGroupComponent implements OnInit {

  @ViewChild('f', {static: false}) aopForm: NgForm;

  @Input() aopShow: boolean;
  @Input() url: string;

  @Input() type: string;
  @Input() printMode?: boolean = false;
  // This was added when aop-group was split into two separate forms:
  //  - General System Operations (type === 'operations')
  //  - Recharge Facilities (type === 'facilities')
  //
  // This will affect the UI by showing either the general AOP form, or the sub-forms related to the project facilities

  @Output() submitEvent = new EventEmitter<boolean>();

  aopId: number;
  aopArray: ProjectFacilityAnnualOperatingPlanApi[];
  aopGroupData: PermitAnnualOperatingPlanApi;
  aopGroupDataInitial: any;
  editMode: boolean = true;

  model = 1;

  selectedPfAop: ProjectFacilityAnnualOperatingPlanApi;
  applicationPackage: ApplicationPackage;

  permitSponsorsTobeDeleted: ProjectFacilitySponsorApi[] = [];
  permitSponsors: ProjectFacilitySponsorApi[] = [];
  conversionBasis: ListPerAcreFootCostBasisForRecharge[] = [];

  deleteSponsorIndex: number = -1;
  
  private unsubscribe: Subject<any> = new Subject();

  constructor(
    private route: ActivatedRoute,
    private toastrService: ToastrService,
    private modalService: NgbModal,
    private dbListService: DblistService,
    private projectFacilityAopService: PermitProjectFacilityAopService,
    private aopService: PermitAopService,
    private applicationPackageService: ApplicationPackageService,
    private projectFacilityService: PermitProjectFacilityService,
    private projectFacilitySponsorService: ProjectFacilitySponsorService
  ) { }

  ngOnInit() {

    this.aopArray = [];

    this.aopGroupDataInitial = { canEdit: true };

    this.aopGroupData = this.aopGroupDataInitial;

    this.aopService.currentAop
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(aop => {
      if(!!aop) {
        this.aopGroupData = aop;
        this.aopId = this.aopGroupData.permitAnnualOperatingPlanId;
        this.projectFacilityService.getFacilitiesByAopId(aop.permitAnnualOperatingPlanId);
        this.projectFacilitySponsorService.getSponsors(this.aopGroupData.permitAnnualOperatingPlanId);
        this.submitEvent.emit(true);
        this.editMode = false;
      } else {
        this.projectFacilityAopService.changePfaops([]);
      }
    });

    this.projectFacilityAopService.currentProjectFacilityAops
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(aops => {
      this.aopArray = aops;
      if (!!this.aopArray && this.aopArray.length === 1)
      {
        this.selectedPfAop = this.aopArray[0];
      }
    });

    this.projectFacilityAopService.currentProjectFacilityAopSelected
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(aop => {
      this.selectedPfAop = aop;
    });

    this.applicationPackageService.currentApplicationPackage
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(applicationPackage => {
      if (!!applicationPackage) {
        this.aopGroupData.applicationPackageId = applicationPackage.applicationPackageId;
        //this.aopGroupData.permitApplicationId = applicationPackage.permitApplicationId;
        //this.projectFacilityService.getFacilities(applicationPackage.permitPointOfDiversionId);
        this.applicationPackage = applicationPackage;
      }
    });

    this.projectFacilitySponsorService.aopSponsors$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(sponsors => {
      this.permitSponsors = sponsors;
      this.permitSponsorsTobeDeleted = [];
      if (!this.permitSponsors) {
        this.permitSponsors = [];
      }
    });

    this.dbListService.listPerAcreFootCostBasisForRecharge$
    .pipe(takeUntil(this.unsubscribe))
    .subscribe(conv => {
      this.conversionBasis = conv;
    });

  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  submit() {
    if (this.aopGroupData.facilityUseHydro == null || this.aopGroupData.facilityUseStorage == null || this.aopGroupData.facilityUseIrrigation == null) {
      this.toastrService.error("Please select Yes or No on each General System Operations use case question.", "Error:");
    } else {
      this.aopService.putAop(this.aopGroupData);

      //do sponsor update
      //the permitSponsorsTobeDeleted is already checked against facility aop association
      this.projectFacilitySponsorService.putSponsors(this.aopGroupData.permitAnnualOperatingPlanId, this.permitSponsors);

      this.permitSponsorsTobeDeleted = [];
      this.deleteSponsorIndex = -1;
      this.editMode = false;
      this.submitEvent.emit(true);
    }
  }

  open(content) {
    this.modalService.open(content, {ariaLabelledBy: 'modal-basic-title'});
  }

  edit() {
    this.editMode = true;
  }

  listEvent($event) {
    if (this.aopGroupData.hasOwnProperty($event.listName)) {
      this.aopGroupData[$event.listName] = $event.listId;
    }
    if ($event.index == null || $event.listName == null) {
      return;
    }
    this.permitSponsors[$event.index][$event.listName] = $event.listId;
    //this.projectFacilitySponsorService.putSponsors(this.aopGroupData.permitAnnualOperatingPlanId, this.permitSponsors);
    //this.editMode = false;
  }

  generateSponsor() {
    this.permitSponsors.push({
      projectFacilitySponsorId: 0,
      permitAnnualOperatingPlanId: this.aopGroupData.permitAnnualOperatingPlanId,
      payingEntityName: '',
      listPerAcreFootCostBasisForRechargeId: null,
      maxVolumePerYearAF: null,
      contractFileUploadListId: null,
    });
    this.toastrService.success('Added a new Sponsor');
  }

  updateListCostBaseSelection(i: number, $event) {
    if (!!this.permitSponsors && this.permitSponsors.length> i) {
      var sponsor = this.permitSponsors[i];
      for( var j=0; j < this.conversionBasis.length; j++ ) {
        if ($event.currentTarget.value == this.conversionBasis[j].name) {
          sponsor.listPerAcreFootCostBasisForRechargeId = +this.conversionBasis[j].listPerAcreFootCostBasisForRechargeId;
          break;
        }
      }
    }
  }

  isSponsorInUse(i: number) : boolean {
    for (var j=0; j < this.aopArray.length; j++) {
      for (var k=0; k<this.aopArray[j].projectFacilitySponsorApiList.length; k++) {
        if (this.aopArray[j].projectFacilitySponsorApiList[k].projectFacilitySponsorId === this.permitSponsors[i].projectFacilitySponsorId) {
          return true;
        }
      }
    }
    return false;
  }

  removeSponsor(i: number) {
    var canDeleteSponsor = true;
    var facilityName = '';
    for (var j=0; j < this.aopArray.length; j++) {
      for (var k=0; k<this.aopArray[j].projectFacilitySponsorApiList.length; k++) {
        if (this.aopArray[j].projectFacilitySponsorApiList[k].projectFacilitySponsorId === this.permitSponsors[i].projectFacilitySponsorId) {
          canDeleteSponsor = false;
          facilityName = this.aopArray[j].projectFacilityName;
          break;
        }
      }
    }
    if (!canDeleteSponsor) {
      this.toastrService.info(`Sponsor ${i+1} cannot be deleted,
      it is associated with facility: ${facilityName}.`);
    }
    else {
      this.permitSponsorsTobeDeleted.push(this.permitSponsors[i]);
      this.permitSponsors.splice(i,1);
    }

    this.deleteSponsorIndex = -1;
    this.modalService.dismissAll();
  }

}
